export const appRoutes = {
	startpage: '/',
	login: '/login',
	logout: '/logout',
	loanPage: '/loan',
	homePage: '/home',
	savePage: '/save',
	supportPage: '/support',
	userPage: '/user',
	callbackPage: '/callback',
	errorPage: '/errorpage',
	logoutCallback: '/logoutcallback',
	signicatCallback: '/signicatcallback',
	eParakstsCallback: '/eparakstscallback',
	bankIdCallbackPage: '/bankid-callback',
	norwegianBankIdCallback: '/norwegianbankidcallback',
}